import React, { Component } from "react";
import { RichTextEditor } from "@mantine/rte";
import "./editor.css";

let refreshKey = 1;

export default class TextEditer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
      keyValue: props.keyValue,
    };
  }

  componentWillReceiveProps = (props) => {
    this.setState({
      value: props.value,
      keyValue: props.keyValue,
    });
  };

  onChange = (value) => {
    if (!this.props.disabled) { 
      this.setState({ value });
      if (this.props.onChange) {
        this.props.onChange(value, this.props.keyValue);
      }
    }
  };

  render() {
    const { value } = this.state;
    const { label, required, error, disabled, height } = this.props;

    return (
      <div className="fieldset w-100 tooltip-text-editor">
        {label && (
          <label
            className={
              error
                ? "form-label-error mylabel control-label"
                : "control-label mylabel mb-2"
            }
          >
            {label}
          </label>
        )}

        <div className={required ? "mandatory input-group" : "input-group mb-2"}>
          <div className="block_Quote w-100">
            <RichTextEditor
              value={value}
              key={refreshKey}
              controls={[
                ["bold", "italic", "underline", "link"],
                ["unorderedList", "h1", "h2", "h3"],
                ["sup", "sub"],
                ["alignLeft", "alignCenter", "alignRight"],
              ]}
              onChange={this.onChange}
              styles={{
                blockquote: { color: "red", display: "inline-block" },
                content: height ? { minHeight: height } : {}
              }}
              readOnly={disabled}  // This makes the editor read-only when disabled
            />
          </div>
        </div>
      </div>
    );
  }
}
